import { RefObject, useState, useEffect } from 'react';

export function useOffsetWidth(ref: RefObject<HTMLElement | null>): number {
    const [width, setWidth] = useState(0);

    useEffect(() => {
        const { current: el } = ref;
        if (el === null) {
            return;
        }
        const observer = new ResizeObserver(() => {
            setWidth(el.offsetWidth);
        });
        observer.observe(el);
        return (): void => {
            observer.unobserve(el);
        };
    }, []);

    return width;
}
